var ValidationHandler = {
    methods: {
        initValidator(fields){
            fields.forEach(field => {
                this.$set(this.errors, field, {message: []})
            })
        },
        clearErrors(){
            Object.keys(this.errors).forEach(item => {
                this.errors[item].message = []
            })
        },
        getValidationErrors(response) {
            let message = ''
            // Loop through each error message and add it to our message variable
            Object.keys(response.data.errors).forEach(item => {
                const field = response.data.errors[item]
                for (let i = 0; i < field.length; i++) {
                    if(!!this.errors[item]){
                        this.errors[item].message = response.data.errors[item]
                    }
                }
            })
        },
    },
    data() {
        return {
            errors: {}
        }
    }
}

export default ValidationHandler



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/ValidationHandler.js